import React from 'react';
import { Switch, Route, RouteComponentProps, Redirect } from 'react-router-dom';
import ui from 'stores/ui';

import GP2T from './modules/GP2T';

const Market: React.FC<RouteComponentProps> = props => {
    ui.setPid('market');

    const { path } = props.match;

    return (
        <div className="page-market-root">
            <Switch>
                <Route path={`${path}/gp2t`} component={GP2T} />
                <Redirect to={{ ...props.location, pathname: `${path}/gp2t` }} />
            </Switch>
        </div>
    );
};

export default Market;
